import React from 'react';

import { connect } from 'react-redux';

import Button from '@/components/elements/Button';
import CMSContext from '@/contexts/CMSContext';
import { selectCelebrationsIsFlowActive } from '@/ducks/programs/celebrations/selectors';
import { selectMgm } from '@/ducks/programs/mgm/selectors';
import { FormattedMessage } from '@/helpers/formatted-message';
import tagmanager from '@/tagmanager';
import { withTrackPopupState } from '@/tagmanager/hocs';

import PromotionBonusModal from '../PromotionBonusModal/PromotionBonusModal';

class PgmXOutModal extends React.Component {
  onButtonClick = (toBookingFunnel) => (e) => {
    const { onCloseModal } = this.props;

    const buttonText = toBookingFunnel ? tagmanager.eventBuilder.buildCtaLabel(e.target.innerText) : e.target.innerText;
    tagmanager.tracker.common.trackButtonClick({
      labels: [buttonText],
      module: tagmanager.trackerConstants.FLYOUTS.SAIL_WITH_CELEBRATIONS_MODULE_POPUP_X_OUT,
    });

    onCloseModal(!toBookingFunnel);
  };

  onTermsLinkClick = (e) => {
    // "terms and conditions" link is received from CMS,
    // so we're listening to bubbled event and have to check target node
    if (e.target.tagName.toUpperCase() !== 'A') {
      return;
    }

    tagmanager.tracker.common.trackLinkClick({
      label: tagmanager.trackerConstants.EVENT_LABELS.TERMS_AND_CONDITIONS,
      module: tagmanager.trackerConstants.FLYOUTS.SAIL_WITH_CELEBRATIONS_MODULE_POPUP_X_OUT,
    });
  };

  render() {
    const { isCelebrationFlow, isOpen, mgm, onCloseModal, program = 'mgm' } = this.props;
    const referredBooker = isCelebrationFlow ? true : mgm.isReferredBooker;

    return (
      <>
        {referredBooker && (
          <CMSContext.Consumer>
            {(cms) =>
              cms.content && (
                <PromotionBonusModal
                  captionText={cms.get(`${program}.largeImage.metadata.caption`) || ''}
                  description={cms.get(`${program}.vv-form.warningDescription`)}
                  hidePromoImage
                  imgSrc={cms.get(`${program}.largeImage.@link`)}
                  isOpen={isOpen}
                  onCloseModal={onCloseModal}
                  title={cms.get(`${program}.vv-form.warningTitle`)}
                >
                  <Button block onClick={this.onButtonClick(true)} variant="secondary">
                    <FormattedMessage
                      defaultMessage={cms.get(`${program}.vv-form.warningAcceptCTA`)}
                      id="VoyageCard.PromotionBonusModal.choose"
                    />
                  </Button>
                  <Button block onClick={this.onButtonClick(false)} variant="secondary">
                    <FormattedMessage
                      defaultMessage={cms.get(`${program}.vv-form.warningRejectCTA`)}
                      id="VoyageCard.PromotionBonusModal.cancel"
                    />
                  </Button>
                  <p
                    className="modalTermsAndConditions"
                    onClick={this.onTermsLinkClick}
                    onKeyDown={this.onTermsLinkClick}
                    role="presentation"
                  >
                    <span
                      className="modalTermsAndConditions"
                      dangerouslySetInnerHTML={{ __html: cms.get(`${program}.vv-form.rulesBlock`) }}
                    />
                  </p>
                </PromotionBonusModal>
              )
            }
          </CMSContext.Consumer>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isCelebrationFlow: selectCelebrationsIsFlowActive(state),
  mgm: selectMgm(state),
});

export default connect(mapStateToProps)(
  withTrackPopupState({
    Component: PgmXOutModal,
    onToggleState: (isOpen) =>
      tagmanager.tracker.common.trackPopupState({
        isOpen,
        module: tagmanager.trackerConstants.FLYOUTS.SAIL_WITH_CELEBRATIONS_MODULE_POPUP_X_OUT,
      }),
  }),
);
